import { Role } from './auth';

export type UserOwnedAssets = {
    avatarFrames: AvatarFrame[];
    backgrounds: Background[];
    characters: Character[];
};

export interface Background {
    id: string;
    colour: string; // Hex value
    imagePath: string;
    name: string;
    price: number;
    rivFileURL: string;
    thumbnailPath: string;
}

export interface Character {
    id: string;
    imagePath: string;
    name: string;
    price: number;
    rivFileURL: string;
    thumbnailPath: string;
}

export interface AvatarFrame {
    id: string;
    imagePath: string;
    name: string;
    price: number;
}

export interface Faction {
    id: string;
    name: string;
    imagePath: string;
    iconPath: string;
    iconImageUrl: string; // Calculated, not from API
    rankImagePath: string;
}

export interface Rank {
    id: string; // 'survivor_3'
    rankLevel: number;
    name: string;
    rankColour: string; // '#808080'
    totalPoints: number;
}

export interface FactionSettings {
    id: string;
    universeID: string;
    factionPickerTitle: string;
    factionCardSubtitle: string;
    factionCardBackgroundImagePath: string;
    factionCardTextBackgroundImagePath: string;
    factionCardHighlightImagePath: string;
    factions: Faction[];
}

export type BanReason = 'short_ban' | 'permanent_ban' | 'rate_limit_exceeded';

export interface Profile {
    id: string;
    universeID: string;
    displayName: string;
    factionID: string;
    avatarFrame: AvatarFrame;
    background: Background;
    character: Character;
    createdAt: string;
    updatedAt: string;
    userID: string;
    faction: Faction;
    supplyRunRank: Rank;
    title: Title;
    role: Role;
    fetchedAt: number; // Calculated, not from API

    isBanned?: boolean; // Calculated, not from API
    bannedUntil?: string;
    bannedReason?: BanReason;

    // These are computed properties that are not returned from the server
    factionImageUrl: string;
}

export type Rarity = 'Common' | 'Uncommon' | 'Rare' | 'Epic' | 'Legendary';

export type ProfileAssetType = 'background' | 'character' | 'avatar_frame';

export interface Title {
    id: string;
    titleID?: string;
    title: string;
    rarity: Rarity;
}

export interface StorageProfile extends Profile {
    fetchedAt: number;
}

export function emptyProfile(): Profile {
    return {
        id: '',
        universeID: '',
        displayName: '',
        factionID: '',
        avatarFrame: {
            id: '',
            imagePath: '',
            name: '',
            price: 0,
        },
        background: {
            id: '',
            colour: '',
            imagePath: '',
            name: '',
            price: 0,
            rivFileURL: '',
            thumbnailPath: '',
        },
        character: {
            id: '',
            imagePath: '',
            name: '',
            price: 0,
            rivFileURL: '',
            thumbnailPath: '',
        },
        createdAt: '',
        updatedAt: '',
        userID: '',
        faction: {
            id: '',
            name: '',
            imagePath: '',
            iconPath: '',
            iconImageUrl: '',
            rankImagePath: '',
        },
        supplyRunRank: null,
        title: {
            id: '',
            titleID: undefined,
            title: '',
            rarity: 'Common',
        },
        role: 'user',
        fetchedAt: 0,
        isBanned: false,
        bannedUntil: undefined,
        bannedReason: undefined,
        factionImageUrl: '',
    };
}
